<h2 mat-dialog-title>{{ 'CALLS.AGENDA_EDITOR.REMOVE_NODE_WITH_CHILDREN_DIALOG.TITLE' | translate }}</h2>
<mat-dialog-content class="mat-typography">
  {{ 'CALLS.AGENDA_EDITOR.REMOVE_NODE_WITH_CHILDREN_DIALOG.DESCRIPTION' | translate }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="'keep'" cdkFocusInitial>{{ 'COMMON.KEEP' | translate }}</button>
  <button mat-button [mat-dialog-close]="'remove'" cdkFocusInitial>{{ 'COMMON.REMOVE' | translate }}</button>
</mat-dialog-actions>
